import React from 'react';
import styled from 'styled-components';

import useArrayToggler, {
  ArrayTogglerBehaviorTypes,
} from '../../../../../shared/hooks/useArrayToggler';

function Tabs<T extends unknown, K extends keyof T>({
  name,
  data,
  lookup,
  renderItem,
  actionHandler,
  defaultState,
  setFirstAsDefault = false,
}: // quickFilterOpen,
{
  name: string;
  data: T[];
  lookup: (item: T) => T[K] | T;
  renderItem: (item: T, boolean) => JSX.Element;
  actionHandler: (data: T[]) => void;
  defaultState?: T[];
  setFirstAsDefault?: boolean;
  // quickFilterOpen: boolean;
}) {
  const [isChecked, onClickHandler] = useArrayToggler(
    data,
    lookup,
    ArrayTogglerBehaviorTypes.radio,
    actionHandler,
    defaultState,
  );

  const hasAnySelectedActiveState = data.find(item => isChecked(item));

  return (
    <TabsListWrapper>
      {data.map((item, index) => {
        const isItemChecked =
          isChecked(item) || (!hasAnySelectedActiveState && setFirstAsDefault && index === 0);
        return (
          <TabsListItemWrapper
            // bottomBorderRadius={!quickFilterOpen}
            key={name + String(index)}
            className={
              isItemChecked || (!hasAnySelectedActiveState && setFirstAsDefault && index === 0)
                ? 'active'
                : ''
            }
            onClick={() => onClickHandler(item)}
          >
            {renderItem(item, isItemChecked)}
          </TabsListItemWrapper>
        );
      })}
    </TabsListWrapper>
  );
}

export default React.memo(Tabs);

export const TabsListWrapper = styled.ul(
  props => `
  display: flex;
  height:5rem;
`,
);

export const TabsListItemWrapper = styled.li(
  props => `
  display: flex;
  padding: 0 ${props.theme.spacing.custom(12)};
  border-radius:${props.theme.misc.borderRadius.xxxlarge}  ${
    props.theme.misc.borderRadius.xxxlarge
  } 0 0;
  background-color: ${props.theme.colors.goWhite.base};
  opacity: 0.7;
  margin-right: ${props.theme.spacing.base};
  cursor: pointer;
  span {
    width:auto;
    padding-left:${props.theme.spacing.base};
    font-size: ${props.theme.font.custom(14)};
    color: ${props.theme.colors.downriver.dark};
  }
  &.active {
    opacity: 1;
    span {
      font-weight: bold;
    }
    i {
      color: #2276e3;
    }
  }
`,
);
